// extracted by mini-css-extract-plugin
module.exports = {"root":"team_root__1MTiv","content":"team_content__2FYB_"};